import React from 'react';
import { format } from 'date-fns';
import { Download } from 'lucide-react';

const ScrollableTable = ({ data, theads }) => {
  return (
    <div className="overflow-x-auto p-4"> 
      <table className="min-w-full divide-y divide-gray-200 shadow-sm rounded-lg overflow-hidden">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">#</th>
            {theads.map((thead, index) => (
              <th key={index} className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                {thead}
              </th>
            ))}
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {data &&
            data.map((item, index) => (
              <tr key={item.index} className="hover:bg-gray-50 transition-colors">
                <td className="px-4 py-4 text-sm text-gray-900">{index + 1}</td>
                <td className="px-4 py-4 text-sm text-gray-900">{item.class}</td>
                <td className="px-4 py-4 text-sm text-gray-900">{item.subject}</td>
                <td className="px-4 py-4 text-sm text-gray-900">{item.title}</td>
                {item.description && <td className="px-4 py-4 text-sm text-gray-900">{item.description}</td>}
                <td className="px-4 py-4 text-sm text-gray-900">
                  {format(new Date(item.created_at), 'MMM dd, yyyy')}
                </td>
                {item.submit_by && (
                  <td className="px-4 py-4 text-sm text-gray-900">
                    {format(new Date(item.submit_by), 'MMM dd, yyyy')}
                  </td>
                )}
                <td className="px-4 py-4 text-sm text-gray-900">
                  <a
                    href={`https://drive.google.com/uc?export=download&id=${item?.file_id}`}
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-800"
                  >
                    <Download size={20} />
                  </a>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default ScrollableTable;